import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { Stepper } from '@/design_system/Stepper/Stepper';
import { Cell } from '@/design_system/Table/Table';
import IconArchive from '@/icons/Archive.svg';
import IconDone from '@/icons/Done.svg';
import { ShipmentWithRelations } from '@/models/shipment';
import { useShipmentStepsToDisplay } from '@/routes/Shipments/Shipment/components/ShipmentStep/ShipmentStep';

export const ShipmentStepCell = ({ shipment }: { shipment: ShipmentWithRelations }) => {
  const steps = useShipmentStepsToDisplay(shipment);

  return (
    <Cell>
      {shipment.status === 'validated' ? (
        <Stack className="text-success" row alignItems="center" gap="0.5rem">
          <IconDone style={{ fontSize: '1.25rem' }} />
          <Trans id="shipment.status.validated">Validated</Trans>
        </Stack>
      ) : shipment.archivedAt ? (
        <Stack className="text-warning" row alignItems="center" gap="0.5rem">
          <IconArchive style={{ fontSize: '1.25rem' }} />
          <Trans id="shipment.status.archived">Archived</Trans>
        </Stack>
      ) : (
        <Stepper variant="round" size="medium" steps={steps} />
      )}
    </Cell>
  );
};
